module.exports = __webpack_public_path__ + "static/img/che04.715c548.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che04.png
// module id = BUuJ
// module chunks = 1